import dayjs from 'dayjs';
import * as Yup from 'yup';

export const RegularizationRequestValidationSchema = (leave) =>
  Yup.object({
    ...(leave
      ? {}
      : {
          reg_date: Yup.string()
            .matches(/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/, 'Date is required')
            .required('Date is required')
            .test('current-month', 'Need to be current month', (value) => {
              if (!value) return false;

              const selectedDate = dayjs(value, 'YYYY-MM-DD', true);
              if (!selectedDate.isValid()) return false;

              const now = dayjs();

              return (
                selectedDate.year() === now.year() && selectedDate.month() === now.month() // month is 0-based
              );
            }),

          reg_check_in: Yup.string()
            .matches(/^(?:[01]\d|2[0-3]):[0-5]\d$/, 'Check In is required')
            .required('Check In is required'),

          reg_check_out: Yup.string()
            .matches(/^(?:[01]\d|2[0-3]):[0-5]\d$/, 'Check Out is required')
            .required('Check Out is required')
            .test('is-after-check-in', 'Check Out must be after Check In', function (value) {
              const { reg_check_in } = this.parent;

              if (!reg_check_in || !value) return true;

              const [inH, inM] = reg_check_in.split(':').map(Number);
              const [outH, outM] = value.split(':').map(Number);

              const inMinutes = inH * 60 + inM;
              const outMinutes = outH * 60 + outM;

              return outMinutes >= inMinutes;
            }),
        }),

    reg_reason: Yup.string().min(4, 'should be minimum 4 letters').required('Reason is required'),
  });
